module.exports = __webpack_public_path__ + "assets/img/logo.ec7f2dc4.png";